function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "abonnement actif");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Wago-v1.2-(\\xE9volutions)",
  stroke: "none",
  strokeWidth: 1
}, /*#__PURE__*/React.createElement("g", {
  id: "Pictos",
  transform: "translate(-254.000000, -83.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M327.411333,83 L263.176417,83 C258.129387,83 254.045882,87.1293875 254.045882,92.1764166 L254,151.50195 C254,154.667814 255.605873,157.466621 258.037623,159.118376 L292.77036,182.242946 C294.330351,183.252351 296.303281,183.252351 297.863271,182.242946 L332.550126,159.118376 C334.981877,157.466621 336.587749,154.667814 336.587749,151.50195 L336.587749,92.1764166 C336.587749,87.1293875 332.458362,83 327.411333,83 L327.411333,83 Z M324.199587,113.740996 L289.375086,148.565497 C287.585685,150.354898 284.695114,150.354898 282.905712,148.565497 L266.434045,132.093829 C264.644643,130.304428 264.644643,127.413856 266.434045,125.624455 C268.223446,123.835054 271.114017,123.835054 272.903418,125.624455 L286.117458,138.838495 L317.684331,107.271622 C319.473733,105.482221 322.364304,105.482221 324.153705,107.271622 C325.943106,109.061023 325.988988,111.951594 324.199587,113.740996 Z",
  id: "abonnement-actif"
})));

var SvgActiveSubscription = function SvgActiveSubscription(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "83px",
    height: "100px",
    viewBox: "0 0 83 100",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgActiveSubscription, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/active_subscription.2021e472.svg";
export { ForwardRef as ReactComponent };